import React from 'react';
import { Hero } from '../components/home/Hero';
import { WhatIsSCB300 } from '../components/home/WhatIsSCB300';
import { CoreValues } from '../components/home/CoreValues';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { WhyDTech } from '../components/home/WhyDTech';
import { Applications } from '../components/home/Applications';
import { DemoRequest } from '../components/home/DemoRequest';
import { ContactSection } from '../components/home/ContactSection';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-635">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-636" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-637" />
      <WhatIsSCB300 data-id="element-638" />
      <CoreValues data-id="element-639" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-640" />
      <WhyDTech data-id="element-641" />
      <Applications data-id="element-642" />
      <DemoRequest onRequestQuote={() => onRequestQuote()} data-id="element-643" />
      <ContactSection data-id="element-644" />
    </main>;
}